import { render, staticRenderFns } from "./CockpitCard.vue?vue&type=template&id=1a867724&scoped=true&"
import script from "./CockpitCard.vue?vue&type=script&lang=ts&"
export * from "./CockpitCard.vue?vue&type=script&lang=ts&"
import style0 from "./CockpitCard.vue?vue&type=style&index=0&id=1a867724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a867724",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VHover,VImg,VList})
